import { Autocomplete, Chip, MenuItem, TextField } from '@mui/material';
import { GridFilterInputValueProps } from '@mui/x-data-grid';
import React from 'react';

import { ExamAvatar } from './ExamAvatar';
import { EXAM_ICON_NAMES } from 'FRONTEND/utils/constants';
import i18n from 'FRONTEND/utils/i18n';

type ExamOption = { value: string, label: string };

export const ExamFilterInput = ({ item, applyValue, focusElementRef, apiRef }: GridFilterInputValueProps) => {
  const examIconTranslationMap: Record<string, string> = {
    interview: i18n._('Interview'),
    nibp: i18n._('NIBP'),
    oximetry: i18n._('Oximetry'),
    ecg: i18n._('ECG'),
    spiro: i18n._('Spirometry'),
    heart_rate: i18n._('Heart rate'),
    glucose: i18n._('Glucose'),
    photo: i18n._('Photo'),
    video: i18n._('Video'),
    respiratory_rate: i18n._('Respiratory rate'),
    temperature: i18n._('Temperature'),
    attachments: i18n._('Attachments'),
  };

  const options: ExamOption[] = EXAM_ICON_NAMES.map(exam => ({ value: exam, label: examIconTranslationMap[exam] ?? exam }));

  const selectedValues: string[] = (item.value as string[]) ?? [];
  const selectedOptions = selectedValues.map(v => options.find(o => o.value === v) ?? { value: v, label: v });

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.label}
      value={selectedOptions}
      onChange={(_, newValue) => applyValue({ ...item, value: newValue.map(o => o.value) })}
      renderOption={(props, option) => (
        <MenuItem {...props} key={option.value} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, fontSize: '14px' }}>
          <ExamAvatar icon={option.value} />
          {option.label}
        </MenuItem>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.value}
            size='small'
            label={option.label}
            avatar={<ExamAvatar icon={option.value} />}
          />
        ))}
      renderInput={(params) => (
        <TextField {...params} inputRef={focusElementRef} label='Value' variant='standard' />
      )}
      sx={{ minWidth: 200 }}
    />
  );
};
